module.exports = __webpack_public_path__ + "media/images/survivor-9c6ae42c80e4d6c3aa18536cff4f9d0b.svg";